import { lazy } from 'react';

import { ReactWebComponent } from '@app/utils/web-components';

const PageRoot = lazy(() => import('@app/components/PageRoot'));
const TeamBillingOverview = lazy(() => import('./TeamBillingOverview'));

class TeamBillingOverviewWebComponent extends ReactWebComponent {
    static get observedAttributes() {
        return ['team-id', 'team-uuid', 'ota-enabled'];
    }

    render() {
        return (
            <PageRoot>
                <TeamBillingOverview
                    teamId={Number(this.prop('team-id'))}
                    teamUuid={this.prop('team-uuid')}
                    isOtaEnabled={this.prop('ota-enabled') === '1'}
                />
            </PageRoot>
        );
    }
}

customElements.define('team-billing-overview', TeamBillingOverviewWebComponent);
